import React, { useEffect, useState } from 'react'
import { createColumn } from '../../../../_components/TableColumn'
import { Table } from '../../../../_components/Table'
//Helpers
import { WebWorker } from '../../../../_helpers/webworker'
import { feeDataWorker } from './feeDataWorker'

const FeeTable = ({ fee }) => {
  const [worker, setWorker] = useState()
  const [exampleFeeData, setExampleFeeData] = useState([])
  const [waitingForFees, setWaitingForFees] = useState(true)
  useEffect(() => {
    //Turns out generating sample fee data is super expensive, so it is done in a web worker
    let w = new WebWorker(feeDataWorker)
    w.addEventListener('message', (event) => {
      setExampleFeeData(event.data.data)
      setWaitingForFees(false)
    })
    let startMessage = { event: 'generate_data', fee }
    w.postMessage(startMessage)
    setWorker(w)
    return () => {
      if (worker) {
        worker.terminate()
      }
    }
  }, [])

  useEffect(() => {
    if (worker) {
      setWaitingForFees(true)
      worker.postMessage({ event: 'generate_data', fee })
    }
  }, [fee])
  return (
    <Table
      columns={[
        {
          accessor: 'day',
          headingText: 'Day',
          disableSortBy: true,
        },
        createColumn({
          type: 'precise-percentage',
          id: 'rate',
          headingText: 'Rate',
          precision: 2,
          disableSortBy: true,
        }),
      ]}
      data={exampleFeeData}
    />
  )
}
const memoizedTable = React.memo(FeeTable)
export { memoizedTable as FeeTable }
